import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GateConfigComponent = _resolveComponent("GateConfigComponent")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("h5", null, _toDisplayString(_ctx.labelDescription), 1)
        ]),
        _createVNode(_component_ElScrollbar, { class: "list" }, {
          default: _withCtx(() => [
            _createVNode(_component_GateConfigComponent, {
              gatesToConfigure: _ctx.gatesToConfigure,
              availableScsAddressGate: _ctx.availableScsAddressGate,
              onAnyScsError: _ctx.updateScsError
            }, null, 8, ["gatesToConfigure", "availableScsAddressGate", "onAnyScsError"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_6, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: !_ctx.nextEnabled
      }, null, 8, ["onClick", "label", "disabled"])
    ])
  ], 64))
}